import api from "@/shared/api";

export const getOpportunities = async (params = {}) => {
  const response = await api.get("/opportunities", { params });
  return response;
};

export const getOpportunity = async (opportunityId) => {
  const response = await api.get(`/opportunities/${opportunityId}`);
  return response;
};

export const qualifyOpportunity = async (opportunityId) => {
  const response = await api.post(`/opportunities/${opportunityId}/qualify`);
  return response;
};

export const updateOpportunity = async (opportunityId, data) => {
  const response = await api.patch(`/opportunities/${opportunityId}`, data);
  return response;
};

export const convertLeadToOpportunity = async (leadId) => {
  const response = await api.post("/conversion/lead-to-opportunity", {
    leadId,
  });
  return response;
};

export const getSuggestedProvidersForOpportunity = async (opportunityId) => {
  const response = await api.get(
    `/partners/match-for-opportunity/${opportunityId}`
  );
  return response;
};

export const getSuggestedProvidersForLead = async (leadId) => {
  const response = await api.get(`/partners/match-for-lead/${leadId}`);
  return response;
};
